import { render, staticRenderFns } from "./ScannerInput.vue?vue&type=template&id=5d4afa72&"
import script from "./ScannerInput.vue?vue&type=script&lang=js&"
export * from "./ScannerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports